import { render, staticRenderFns } from "./setGoals.vue?vue&type=template&id=10451b72&scoped=true&"
import script from "./setGoals.vue?vue&type=script&lang=js&"
export * from "./setGoals.vue?vue&type=script&lang=js&"
import style0 from "./setGoals.vue?vue&type=style&index=0&id=10451b72&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10451b72",
  null
  
)

export default component.exports